export class IDialogCustomizado {
    labelMensagem?: string;
    labelConfirmacao?: string;
    labelNegacao?: string;
}